import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2025 FSM 31. Tous droits réservés.</p>
    </footer>
  );
};

export default Footer;